import $ from 'jquery';
import Swiper from '../../node_modules/swiper/js/swiper.min.js';

$.addInit(function(context){
	var base = '.b-personSlider';
	$(base, context).each(function(i, el){
		var items = $(el).find('.b-person');
		var slider = new Swiper (el.querySelector('.b-personSlider-container'), {
			slidesPerView: 'auto',
			spaceBetween: 16,
			watchOverflow: true,
			loop: true,
			loopedSlides: items.length,
			loop: items.length > 1 ? true : false,
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
			slideClass: 'b-person',
			navigation : {
				nextEl : el.querySelector('.b-sliderArrows-btn_next'),
				prevEl : el.querySelector('.b-sliderArrows-btn_prev')
			},
			breakpoints: {
				1380: {
					spaceBetween: 40,
				},
			},
		});
	});
});
